import React__default from 'react';
import { WindowSizeContext } from '../components/provider/WindowSizeContext.js';
var useWindowSize = function useWindowSize() {
  var value = React__default.useContext(WindowSizeContext);
  return value;
};
export { useWindowSize };